import React from "react";

export const MsViewport = () => {
  return (
    <div id="frameholder" className="mv-asset-viewer ms-office__container">
      <iframe
        title="office_frame"
        name="office_frame"
        id="office_frame"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
        className="ms-office__viewport"
        allowFullScreen
      ></iframe>
    </div>
  );
};
